import { createSlice } from '@reduxjs/toolkit';
import { getUserProfileApi } from '../../api/userApi/userApi';

const initialState = {
  isAuthenticated: false,
  role: null,
  loading: false,
  userProfile : '',
  error: null,
  id : '',
  selctedId : [], 
  notificationId : '',
  refresh : false
};

const authSlice = createSlice({
  name: 'auth',
  initialState,
  reducers: {
    loginStart(state) {
      state.loading = true;
      state.error = null;
    },
    loginSuccess(state, action) {
      state.loading = false;
      state.isAuthenticated = true;
      state.role = action.payload.role;
      state.id = action.payload.id;
      state.error = null;
    },
    loginFailure(state, action) {
      state.isAuthenticated = false;
      state.role = null;
      state.loading = false;
      state.error = action.payload;
    },
    logout(state) {
      state.isAuthenticated = false;
      state.role = null; 
      state.selctedId = [];

    },
    fetchUserProfile(state, action) {
      state.userProfile = action.payload;
    },
    setSelectedId(state, action) {
      state.selctedId = action.payload;
    },
    setNotificatioId(state, action){
      state.notificationId = action.payload;
    },
    setLeadPageRefresh(state, action){
      state.refresh = action.payload;
    },
    removeSelectedIds(state) {
      state.selctedId = [];
    },
  },
});

export const { loginStart, loginSuccess, loginFailure, logout, fetchUserProfile, setSelectedId, setNotificatioId, setLeadPageRefresh, removeSelectedIds } = authSlice.actions;

export const getProfile = (decryptedId) => async (dispatch) => {
  try {
   // Replace with your API URL
    const response = await getUserProfileApi(decryptedId); 

    dispatch(fetchUserProfile(response.data.data));

  } catch (error) {
    dispatch(fetchUserProfile({}));
  }
};


export const selectAuth = (state) => state.auth;

export default authSlice.reducer;
